import styled from 'styled-components';
import { motion } from 'framer-motion';

export const Main = styled.section`
  padding: 110px 0;
  position: relative;
  z-index: 10;
  background:
    radial-gradient(circle at 12% 80%, ${(props) => props.theme.text}12 0%, transparent 42%),
    #050505;

  @media screen and (max-width: 768px) {
    padding: 80px 0;
  }
`;

export const MaxWidth = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 50px;

  @media screen and (max-width: 768px) {
    padding: 0 22px;
  }
`;

export const Title = styled(motion.h2)`
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: ${(props) => props.theme.text};
  margin-bottom: 10px;
`;

export const Heading = styled(motion.h1)`
  text-align: center;
  font-size: 42px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 56px;
  font-family: 'Poppins', sans-serif;

  @media screen and (max-width: 768px) {
    font-size: 30px;
    margin-bottom: 40px;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 18px;
`;

export const Card = styled(motion.div)`
  display: flex;
  gap: 16px;
  padding: 22px 22px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.035);
  border: 1px solid rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(8px);
  transition: transform 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease;

  &:hover {
    transform: translateY(-5px);
    border-color: ${(props) => props.theme.text};
    box-shadow: 0 18px 44px -20px ${(props) => props.theme.text};
  }
`;

export const Badge = styled.div`
  flex-shrink: 0;
  width: 46px;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  color: ${(props) => props.theme.text};
  background: ${(props) => props.theme.text}1c;
  border: 1px solid ${(props) => props.theme.text}3a;

  svg {
    font-size: 20px;
  }
`;

export const Info = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Name = styled.h3`
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  line-height: 1.35;
`;

export const Issuer = styled.p`
  font-size: 13.5px;
  color: #8b94a3;
  margin-top: 4px;
`;

export const Foot = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 12px;
`;

export const DateText = styled.span`
  font-size: 12.5px;
  font-weight: 600;
  color: #9aa3b2;
`;

export const Verify = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  font-weight: 700;
  color: ${(props) => props.theme.text};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
